import { useCallback, useEffect, useState } from 'react';
import { decodeJwt } from 'jose';
import { getWidgetBaseUrl } from '@/lib/widget-base';
const ONE_MINUTE_MS = 60 * 1000;
export default function useConnectionDetails(appConfig) {
    const [connectionDetails, setConnectionDetails] = useState(null);
    const [error, setError] = useState(null);
    const fetchConnectionDetails = useCallback(async () => {
        var _a, _b;
        setConnectionDetails(null);
        setError(null);
        const url = new URL((_a = process.env.NEXT_PUBLIC_CONN_DETAILS_ENDPOINT) !== null && _a !== void 0 ? _a : '/api/connection-details', getWidgetBaseUrl());
        let data;
        try {
            const res = await fetch(url.toString(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Sandbox-Id': (_b = appConfig.sandboxId) !== null && _b !== void 0 ? _b : '',
                },
                body: JSON.stringify({
                    room_config: appConfig.agentName
                        ? { agents: [{ agent_name: appConfig.agentName }] }
                        : undefined,
                }),
            });
            if (!res.ok) {
                throw new Error(`Server returned ${res.status}: ${res.statusText}`);
            }
            data = await res.json();
        }
        catch (err) {
            const message = err instanceof Error ? err.message : 'Unknown error';
            console.error('Error fetching connection details:', message);
            setError(message);
            throw new Error('Error fetching connection details!');
        }
        setConnectionDetails(data);
        return data;
    }, [appConfig.sandboxId, appConfig.agentName]);
    useEffect(() => {
        fetchConnectionDetails().catch((err) => {
            console.error('Connection details fetch failed:', err);
        });
    }, [fetchConnectionDetails]);
    const isConnectionDetailsExpired = useCallback(() => {
        const token = connectionDetails === null || connectionDetails === void 0 ? void 0 : connectionDetails.participantToken;
        if (!token) {
            return true;
        }
        const jwtPayload = decodeJwt(token);
        if (!jwtPayload.exp) {
            return true;
        }
        const expiresAtMs = jwtPayload.exp * 1000 - ONE_MINUTE_MS;
        return Date.now() >= expiresAtMs;
    }, [connectionDetails === null || connectionDetails === void 0 ? void 0 : connectionDetails.participantToken]);
    const existingOrRefreshConnectionDetails = useCallback(async () => {
        if (isConnectionDetailsExpired() || !connectionDetails) {
            return fetchConnectionDetails();
        }
        return connectionDetails;
    }, [connectionDetails, fetchConnectionDetails, isConnectionDetailsExpired]);
    return {
        connectionDetails,
        error,
        refreshConnectionDetails: fetchConnectionDetails,
        existingOrRefreshConnectionDetails,
    };
}
